import * as types from "../type/types";

export const setSettings = (settings) => ({
    type: types.SET_SETTINGS,
    payload: settings
})